<div class="notes-tab">
  <!-- Search and Filters -->
  <div class="notes-header">
    <div class="row" style="margin-right: -10px">
      <div class="col-md-3">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchText"
          (ngModelChange)="filterNotes()"
          placeholder="Search notes..."
          aria-label="Search notes"
        />
      </div>
      <div class="col-md-2">
        <select class="form-control" [(ngModel)]="filterStatus" (ngModelChange)="filterNotes()" aria-label="Filter by status">
          <option value="">All Statuses</option>
          <option value="Open">Open</option>
          <option value="Resolved">Resolved</option>
        </select>
      </div>
      <div class="col-md-2">
        <select class="form-control" [(ngModel)]="filterType" (ngModelChange)="filterNotes()" aria-label="Filter by note type">
          <option value="">All Types</option>
          <option *ngFor="let type of noteTypes" [value]="type">{{ type }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateFrom"
          (ngModelChange)="filterNotes()"
          placeholder="From date"
          title="From date"
          aria-label="Filter from date"
        />
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateTo"
          (ngModelChange)="filterNotes()"
          placeholder="To date"
          title="To date"
          aria-label="Filter to date"
        />
      </div>
      <div class="col-md-1">
        <button
          class="btn btn-primary btn-block"
          (click)="openAddNoteModal()"
          [disabled]="!canEdit"
          title="Add Note"
          aria-label="Add note"
        >
          <i class="fa fa-plus"></i> Add
        </button>
      </div>
    </div>
  </div>

  <!-- Note Cards (shared component) -->
  <app-driver-note-cards
    [notes]="filteredNotes"
    [searchText]="searchText"
    [canEdit]="canEdit"
    [loading]="loading"
    [pageSize]="pageSize"
    (editNote)="editNote($event)"
    (deleteNote)="confirmDelete($event)"
  ></app-driver-note-cards>
</div>

<!-- Add/Edit Note Modal (shared component) -->
<app-driver-note-form-modal
  [(visible)]="showAddNoteModal"
  [note]="newNote"
  [driver]="driver"
  [tractors]="tractors"
  [trailers]="trailers"
  [clients]="clients"
  [allClients]="allClients"
  [products]="products"
  [states]="states"
  (saved)="onNoteSaved($event)"
  (closed)="closeAddNoteModal()"
></app-driver-note-form-modal>

<!-- Email Modal -->
<p-dialog
  [(visible)]="showEmailModal"
  [modal]="true"
  [style]="{ width: '500px' }"
  [header]="isAccidentOrIncident(noteForEmail?.type) ? 'Email Options' : 'Send Notification'"
  [closable]="false"
>
  <div class="modal-body">
    <p *ngIf="isAccidentOrIncident(noteForEmail?.type)">
      Would you like to email this note to safety or send the accident form to the driver?
    </p>
    <p *ngIf="isDelayOrBreakdown(noteForEmail?.type)">
      Would you like to email the client or driver about this delay/breakdown?
    </p>

    <!-- Accident/Incident Email Buttons -->
    <div *ngIf="isAccidentOrIncident(noteForEmail?.type)" class="email-buttons">
      <div class="email-button-wrapper">
        <button
          class="btn btn-primary btn-block"
          (click)="emailToSafety()"
          [disabled]="emailingToSafety || emailedToSafety"
        >
          <i class="fa fa-spinner fa-spin" *ngIf="emailingToSafety"></i>
          <i class="fa fa-check" *ngIf="emailedToSafety"></i>
          <i class="fa fa-envelope" *ngIf="!emailingToSafety && !emailedToSafety"></i>
          {{ emailedToSafety ? "Sent to Safety" : "Email to Safety" }}
        </button>
        <div class="text-danger mt-2" *ngIf="emailToSafetyError">{{ emailToSafetyError }}</div>
      </div>

      <div class="email-button-wrapper">
        <button
          class="btn btn-primary btn-block"
          (click)="emailFormToDriver()"
          [disabled]="emailingFormToDriver || emailedFormToDriver"
        >
          <i class="fa fa-spinner fa-spin" *ngIf="emailingFormToDriver"></i>
          <i class="fa fa-check" *ngIf="emailedFormToDriver"></i>
          <i class="fa fa-envelope" *ngIf="!emailingFormToDriver && !emailedFormToDriver"></i>
          {{ emailedFormToDriver ? "Form Sent to Driver" : "Email Form to Driver" }}
        </button>
        <div class="text-danger mt-2" *ngIf="emailFormToDriverError">
          {{ emailFormToDriverError }}
        </div>
      </div>
    </div>

    <!-- Delay/Breakdown Email Buttons -->
    <div *ngIf="isDelayOrBreakdown(noteForEmail?.type)" class="email-buttons">
      <div class="email-button-wrapper">
        <button
          class="btn btn-primary btn-block"
          (click)="emailToClient()"
          [disabled]="emailingToClient || emailedToClient"
        >
          <i class="fa fa-spinner fa-spin" *ngIf="emailingToClient"></i>
          <i class="fa fa-check" *ngIf="emailedToClient"></i>
          <i class="fa fa-envelope" *ngIf="!emailingToClient && !emailedToClient"></i>
          {{ emailedToClient ? "Sent to Client" : "Email Client" }}
        </button>
        <div class="text-danger mt-2" *ngIf="emailToClientError">{{ emailToClientError }}</div>
      </div>

      <div class="email-button-wrapper">
        <button
          class="btn btn-primary btn-block"
          (click)="emailToDriver()"
          [disabled]="emailingToDriver || emailedToDriver"
        >
          <i class="fa fa-spinner fa-spin" *ngIf="emailingToDriver"></i>
          <i class="fa fa-check" *ngIf="emailedToDriver"></i>
          <i class="fa fa-envelope" *ngIf="!emailingToDriver && !emailedToDriver"></i>
          {{ emailedToDriver ? "Sent to Driver" : "Email Driver" }}
        </button>
        <div class="text-danger mt-2" *ngIf="emailToDriverError">{{ emailToDriverError }}</div>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeEmailModal()">Done</button>
    </div>
  </p-footer>
</p-dialog>

<!-- Email Preview Dialog -->
<p-dialog
  [(visible)]="showEmailPreview"
  [modal]="true"
  [style]="{ width: '600px' }"
  header="Email Preview"
  [closable]="true"
  (onHide)="cancelEmailPreview()"
>
  <div class="modal-body email-preview-body">
    <div class="form-group">
      <label>To:</label>
      <input
        type="email"
        class="form-control"
        [(ngModel)]="emailPreview.to"
        [class.is-invalid]="emailValidationErrors.to"
        (input)="clearEmailValidationError('to')"
        aria-label="Email to address"
      />
      <div class="invalid-feedback" *ngIf="emailValidationErrors.to">
        {{ emailValidationErrors.to }}
      </div>
    </div>
    <div class="form-group">
      <label>CC:</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailPreview.ccEmails"
        placeholder="Separate multiple emails with semicolons"
        [class.is-invalid]="emailValidationErrors.cc"
        (input)="clearEmailValidationError('cc')"
        aria-label="Email CC addresses"
      />
      <div class="invalid-feedback" *ngIf="emailValidationErrors.cc">
        {{ emailValidationErrors.cc }}
      </div>
    </div>
    <div class="form-group">
      <label>Subject:</label>
      <input type="text" class="form-control" [(ngModel)]="emailPreview.subject" aria-label="Email subject" />
    </div>
    <div class="form-group">
      <label>Body:</label>
      <textarea class="form-control" [(ngModel)]="emailPreview.body" rows="10" aria-label="Email body"></textarea>
    </div>

    <!-- File Attachments -->
    <div class="form-group">
      <label>Attachments (Images):</label>
      <div class="attachment-upload">
        <label class="btn btn-sm btn-outline-secondary attachment-btn">
          <i class="fa fa-paperclip"></i> Add Images
          <input
            type="file"
            accept="image/*"
            multiple
            (change)="onFilesSelected($event)"
            style="display: none"
            aria-label="Add image attachments"
          />
        </label>
      </div>
      <div class="attachment-list" *ngIf="emailAttachments.length > 0">
        <div class="attachment-item" *ngFor="let file of emailAttachments; let i = index">
          <i class="fa fa-file-image-o"></i>
          <span class="attachment-name">{{ file.name }}</span>
          <span class="attachment-size">({{ formatFileSize(file.size) }})</span>
          <button class="btn btn-sm btn-link text-danger" (click)="removeAttachment(i)" aria-label="Remove attachment">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="cancelEmailPreview()">Cancel</button>
      <button class="btn btn-primary" (click)="confirmSendEmail()">
        <i class="fa fa-paper-plane"></i> Send Email
      </button>
    </div>
  </p-footer>
</p-dialog>

<!-- Delete Confirmation Modal -->
<p-confirmDialog
  header="Confirm Delete"
  icon="pi pi-exclamation-triangle"
  [style]="{ width: '450px' }"
></p-confirmDialog>
